<script setup lang="ts">
import { MetricValue } from '@Shared/utils/types';
import { Type, getMetricColour, calculateMetricValue } from '../utility';

const props = defineProps<{
  title?: string;
  scores?: MetricValue[];
  type?: Type;
  loading?: boolean;
}>();

const { title, type, scores } = toRefs(props);

const backgroundColor = computed(() => {
  if (type.value === Type.Negative) {
    return 'bg-#D4002B';
  } else if (type.value === Type.Positive) {
    return 'bg-#0C8A65';
  } else {
    return 'bg-#2C3647';
  }
});
</script>
<template>
  <div class="flex flex-col">
    <template v-if="loading">
      <div :class="[backgroundColor]" class="flex rounded-t justify-center items-center py-3 min-h-0"></div>
      <div class="flex bg-white rounded-b flex-grow p-5 justify-center">
        <div class="loading-gradient-static h-15 w-40"></div>
      </div>
    </template>
    <template v-if="!loading">
      <div :class="[backgroundColor]" class="flex rounded-t justify-center items-center py-3 min-h-0">
        <div class="flex text-white text-xs font-normal font-family[Roboto] uppercase truncate">
          {{ title }}
        </div>
      </div>
      <div :class="[backgroundColor]" class="flex min-h-0 pb-1" v-if="scores && scores.length > 1">
        <div
          v-for="score in scores"
          :key="score.label"
          :style="{
            // We want to make sure the titles align with the values so just using a simple width
            width: `calc(100% / ${scores.length})`,
          }"
          class="truncate flex justify-center items-center text-white text-[8px] xl:text-[11px] font-normal font-family[Roboto] uppercase justify-center items-center"
        >
          <slot name="header" :score="score"
            ><span>{{ score.label }}</span></slot
          >
        </div>
      </div>
      <div class="flex bg-white rounded-b divide-x divide-slate-200 flex-grow min-h-0" v-if="scores">
        <div
          v-for="(score, index) in scores"
          :key="score.label"
          :style="{
            width: `calc(100% / ${scores.length})`,
            color: getMetricColour(score.value, score.metricType),
          }"
          class="flex text-neutral-600 font-normal font-family[Roboto] justify-center items-center py-4"
        >
          <slot
            name="data"
            :score="score"
            :index="index"
            :value="calculateMetricValue(score.value, score.metricType, 'N/A')"
            >{{ calculateMetricValue(score.value, score.metricType, 'N/A') }}</slot
          >
        </div>
      </div></template
    >
  </div>
</template>
